import { computed,inject, unref,toRaw } from "vue";
import { normalizeReadOnlyAnalyzer } from "../../xmlrdb-metadata/ReadOnlyAnalyzer";
import XMLRDBReadOnlyAnalyzer from "../../xmlrdb-metadata/XMLRDBReadOnlyAnalyzer"

export function getReadOnlyAnalyzer(props) {
  let injRoa = inject("readOnlyAnalyzer", XMLRDBReadOnlyAnalyzer.singleton)
  return computed(() => {
    return normalizeReadOnlyAnalyzer(props.readOnlyAnalyzer ?? injRoa);
  })
}
/**
Erzeugt das Viemodel für FormFields.
Diese Funktion ist ausgelagert aus FormField.vue, weil dieses VieModel auch in RadioField benutzt wird.
Zurückgeliefertes Objekt enthält:

isReadOnly: computed - bool
cssClasses: Funktion liefert Liste der CSS-Klassen, die an das FormField geschrieben werden sollen
errorMessages:  Funktion liefert Fehlermeldungen; Falls keine Fehlermeldungen: Liefert undefined
*/
export default function formFieldVM(props) {  
  
    /**
   * Liefert einen Readonly-Analyzer fuer das Feld.
   * Wo kommt der her?
   * a) Das Feld hat einen konkreten gesetzt (ueber Component-Parameter)
   * b) Ein Parent-Component ... TODO
   * c) TheStandardReadOnlyAnalyzer (liest readOnly-tags aus)
  */

  const roa = getReadOnlyAnalyzer(props);
  
  const isReadOnly = computed(() => {
    return roa.value.isReadOnly(props.attribute, props.attribute?.dataElement);
  });
    
  function errorMessages() {
    if (isReadOnly.value) {
      return null;
    }
    let result = null;
    for (let err of props.attribute.validatorResult.value) {
      if (result === null) result = err.message;
      else result += "\n" + err.message;
    }
    return result;
  }

  function cssClasses (){
    const result = [props.attribute.metadata.tagType(), props.attribute.metadata.name()];
    if (!isReadOnly.value) result.push("EDITABLE_"+ props.attribute.metadata.name());
    if (!isReadOnly.value && props.attribute.hasError.value) result.push("VALIDATION_ERROR");  
    if (!isReadOnly.value && props.attribute.hasWarning.value) result.push("VALIDATION_WARNING");  
    if (isReadOnly.value) {
      result.push("READONLY");
    }
    return result;    
  }

  /**
   * @description Liefert Debug-Attribute für das FormField. __USE_PLAYWRIGHT__ ist eine globale Variable zur Transpilezeit.
   * 
   * @returns 
   */
  function debugAttributes(){
    let result = {};
    if (__USE_PLAYWRIGHT__ && props.attribute) {
      result["hy-an"] = props.attribute.metadata.name();
      result["hy-formfield"] = "FormField";
    }
    return result;
  }

  function querySelectors() {
    if (props.attribute && !isReadOnly.value) {
      const qualifier = "[data-hy-id=\"" + props.attribute.dataElement.id.value + "\"]";
      const errorIdentifiers = [
        props.attribute.metadata.name(),
        props.attribute.metadata.name() + qualifier
      ];
      for (let vt of props.attribute.metadata.tagValuesByName("ValidationTag")) {
        errorIdentifiers.push(vt);
        errorIdentifiers.push(vt+qualifier);
      }
      if (props.attribute.hasError.value)
        errorIdentifiers.push(props.attribute.metadata.name() +".VALIDATION_ERROR");

      return errorIdentifiers;
    }
    else
      return [];
  }
  
  // wird nur für Eingebafelder verwendet, nicht readOnly
  const inputStyle = props.attribute?.metadata.inputFieldCSS();
  
  return {
    isReadOnly, cssClasses, errorMessages, inputStyle, querySelectors, debugAttributes
  }
   
}
